import React, { type ComponentType, Suspense } from "react";

import { Spin } from "@eroad/ui-library/Spin";
import { PhoenixProviders } from "@phoenix/providers/PhoenixProviders";

const PhoenixApp = React.lazy(() => import("@phoenix/UI") as Promise<{ default: ComponentType }>);

const App = () => {
  return (
    <Suspense fallback={<SafePageSpinner />}>
      <PhoenixProviders>
        <PhoenixApp />
      </PhoenixProviders>
    </Suspense>
  );
};

// Suspense needs its fallback and we can't rely on our components from @eroad/ui-library
// as we don't yet have access to our theme provider, nor to our translations
// at this point
const SafePageSpinner = () => (
  <div
    style={{
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      right: 0,
      bottom: 0,
      left: 0,
      top: 0,
    }}
  >
    <Spin size="large" />
  </div>
);

export { App };
